import { render, staticRenderFns } from "./abount.vue?vue&type=template&id=3b070333&"
import script from "./abount.vue?vue&type=script&lang=js&"
export * from "./abount.vue?vue&type=script&lang=js&"
import style0 from "./abount.vue?vue&type=style&index=0&id=3b070333&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports